var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-root"},[_vm._m(0),_c('ul',{staticClass:"list lyt-2-columns no-border border-bottom"},_vm._l((_vm.message.content),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.url,"target":"_blank"}},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-header"},[_c('em',{staticClass:"icon-dot"}),_vm._v("相关附件下载 ")])
}]

export { render, staticRenderFns }